import { createDOM } from './helpers/DOMHelper'
import { ease, Easing } from './helpers/EaseHelper'
import View from './View'
/**
 * class MotionCount
 */
class MotionCount extends View {
  /**
   * constructor
   */
  constructor (el, className = '') {
    super(el)
    this._motionData = null
    this.count = 0
    this.displayCount = 0
    this.displayCountBodyMovin = null
    this.isTweening = false
    this.body = createDOM('div', `body ${className}`)
    this.text = createDOM('p', `${className}`)
    this.view.appendChild(this.body)
    this.view.appendChild(this.text)
    this.checkTimeout = null
  }

  set motionData (value) {
    this._motionData = value
    this.displayBodyMovin()
  }

  get motionData () {
    return this._motionData
  }

  setBodyMovinData (data) {
    const movin = window.bodymovin.loadAnimation({
      wrapper: this.body,
      animType: 'svg',
      loop: false,
      autoplay: true,
      prerender: false,
      animationData: data
    })
    movin.addEventListener('complete', () => {
      movin.destroy()
      if (this.displayCount >= 100) return
      this.displayBodyMovin()
    })
  }

  display () {
    this.text.style.display = 'none'
    this.displayCount = this.count
    this.isTweening = true
    ease({ opacity: -1 })
      .to({ opacity: 1 }, 2000)
      .easing(Easing.Cubic.In)
      .onUpdate(prop => this.text.style.opacity = 1 - Math.abs(prop.opacity))
      .onComplete(() => this.isTweening = false)
      .start()
  }

  displayBodyMovin () {
    const availableCount = Object.keys(this.motionData).map(key => parseInt(key, 0)).sort((a,b) => a - b)
    const closest = (value, list) => {
      let output, distance = Number.POSITIVE_INFINITY
      list.map(item => {
        if (Math.abs(item - value) < distance) {
          distance = Math.abs(item - value)
          output = item
        }
        return item
      })
      return output
    }
    const formatTwoDigit = number => number < 10 ? `0${number}` : `${number}`
    this.displayCount = this.count
    this.displayCountBodyMovin = formatTwoDigit(closest(this.count, availableCount))
    if (this.motionData) this.setBodyMovinData(this.motionData[this.displayCountBodyMovin])
  }

  update () {
    return
    /*
    this.text.innerHTML = this.displayCount
    if (!this.isTweening && (this.count > this.displayCount)) {
      this.display()
    }
    */
  }

  setCount (count) {
    this.count = Math.floor(count)
  }
}
export default MotionCount


// WEBPACK FOOTER //
// ./src/scripts/MotionCount.js